import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal, { Overline } from "@/components/Reveal";

const CREDENTIALS = [
  "Founded and sold Strum Music School, Austin TX",
  "75,000 students worldwide through online voice courses",
  "30 years of professional voice & music instruction",
];

export default function Consultant() {
  return (
    <section data-testid="consultant-section" className="bg-[#F7F5F1] py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 sm:px-8 lg:grid-cols-5 lg:gap-20 lg:px-12">
        <Reveal className="lg:col-span-2">
          <div
            data-testid="consultant-photo"
            className="card-shadow-lg relative aspect-[4/5] overflow-hidden rounded-md bg-white"
          >
            <img
              src="/steve-glazer.png"
              alt="Steve Glazer, Executive Voice Consultant and founder of Credible Presence"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#26282E]/95 via-[#26282E]/40 to-transparent p-6 pt-16">
              <p className="font-serif text-xl italic text-[#F7F5F1]">Steve Glazer</p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-[#E3D9C8]">
                Executive Voice Consultant
              </p>
            </div>
          </div>
        </Reveal>
        <div className="flex flex-col justify-center lg:col-span-3">
          <Reveal>
            <Overline>The Consultant</Overline>
            <h2 className="mt-6 font-serif text-3xl leading-[1.15] tracking-tight text-[#26282E] sm:text-4xl">
              The method is mechanics. The outcome is presence.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 text-base leading-relaxed text-[#5B5E66] sm:text-lg">
              Credible Presence is led by an Executive Voice Consultant with specialist expertise in vocal
              mechanics — articulation, projection, breath support, and sustainable professional voice use. The
              training is precise and physiological. The goal is entirely business: a voice that carries your
              credibility into every consequential room.
            </p>
            <p className="mt-5 text-base leading-relaxed text-[#5B5E66] sm:text-lg">
              Based in Austin, Texas, the practice serves executives, founders, attorneys, and senior leaders —
              in person and virtually.
            </p>
          </Reveal>
          <ul className="mt-8 space-y-3">
            {CREDENTIALS.map((c, i) => (
              <Reveal key={i} delay={0.15 + i * 0.07}>
                <li
                  data-testid={`consultant-credential-${i + 1}`}
                  className="border-l border-[#2F5D8C]/40 pl-4 font-mono text-[11px] uppercase tracking-[0.18em] text-[#8A8D94]"
                >
                  {c}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal delay={0.4}>
            <Link
              to="/about"
              data-testid="consultant-about-link"
              className="group mt-10 inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-[#2F5D8C] transition-colors hover:text-[#254A6E]"
            >
              About the Consultant
              <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
